import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const BackLink = ({ toLink, linkText }) => {

    return (
         <Button className="page-back-link" as={Link} to={toLink} variant="link">
            {"<- " + linkText}
        </Button>
    )
}

export default BackLink;